import { BaseWebComponent } from "./webcomponent-base.js";

export class SidebarToggleWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-toggle";
    static observedAttributes = [
        // List of attributes to observe for changes

    ];
    private sidebarElement!: HTMLElement | null;
    constructor() {
        super();
        this.classList.add('sidebar-toggle');
        this.addEventListener('click', (e:Event) => {
            try {
                window.toggleSidebar();
            } catch (error) {
                console.log("Error toggling sidebar:", error);
            }
        });
    }
    protected onConnected(): void {
        this.sidebarElement = this.closest('wc-sidebar');
        
    }
    render(): void {
        this.innerHTML = `<i class="bi bi-chevron-double-left"></i>`;
        
        
    }
}